import {
    validateEmail,
    validateFirstName,
    validateLastName,
    validatePhone,
    validateInternationalPostalCode,
    validateCountry
} from '../Shared/validations';

export const validatePopup = values => {
    const errors = {
        ...validateInternationalPostalCode(values),
        ...validateCountry(values)
    };
    return errors;
};
export const validate = values => {
    const errors = {
        ...validateEmail(values),
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validatePhone(values),
        ...validateInternationalPostalCode(values),
        ...validateCountry(values)
    };
    return errors;
};



// WEBPACK FOOTER //
// ./src/components/Volunteer/validations.js